@if (svg(); as svg) {
    <svg-icon class="width-100 height-100" [src]="svg" [svgStyle]="{ fill: finalColor(), width: '100%', height: '100%' }" />
} @else {
    <i [ngClass]="classes()" [style.color]="finalColor()" [class.icon-spin]="isSpinning()"></i>
}
